import { reveal, SpotlightCard } from "@components/animations";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

/** Show at most this many technology tags, then a "+n" pill (like the demo). */
const MAX_TAGS = 5;

export default function ProjectCard({ data }: IProjectCard) {
  return (
    <div className="anim-project-grid">
      {data?.map((item, index) => {
        const extraTags = item.skills.length - MAX_TAGS;

        return (
          <div key={item?.id} {...reveal("up", index * 80)}>
            <SpotlightCard>
              <div className="anim-card-media">
                <LazyLoadImage
                  alt={item?.title}
                  effect="blur"
                  src={item.cardImage}
                  width={"100%"}
                  height={"100%"}
                />
                <span className="anim-card-overlay" aria-hidden="true" />
                <span className="anim-shine" aria-hidden="true" />
              </div>

              <div className="anim-card__body">
                <div className="anim-tags">
                  {item.skills.slice(0, MAX_TAGS).map((skill) => (
                    <span className="anim-tag" key={skill}>
                      {skill}
                    </span>
                  ))}
                  {extraTags > 0 ? (
                    <span className="anim-tag">+{extraTags}</span>
                  ) : null}
                </div>

                <h3 className="anim-card__title">
                  {item.title}
                  {item?.isPrivate ? (
                    <span className="anim-pill">private</span>
                  ) : null}
                </h3>

                <p className="anim-card__desc">{item?.description}</p>

                <div className="anim-card__actions">
                  {item.liveUrl ? (
                    <a
                      className="anim-btn"
                      href={item.liveUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>Live</span>
                      <span className="anim-btn__arrow" aria-hidden="true">
                        →
                      </span>
                    </a>
                  ) : null}
                  {item.githubUrl ? (
                    <a
                      className="anim-btn anim-btn--ghost"
                      href={item.githubUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>Code</span>
                    </a>
                  ) : null}
                  {item.figma ? (
                    <a
                      className="anim-btn anim-btn--ghost"
                      href={item.figma}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>Figma</span>
                    </a>
                  ) : null}
                  {item.youtubeUrl ? (
                    <a
                      className="anim-btn anim-btn--ghost"
                      href={item.youtubeUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>Demo</span>
                    </a>
                  ) : null}
                </div>
              </div>
            </SpotlightCard>
          </div>
        );
      })}
    </div>
  );
}
